export class DbLocDevice {
  id: number | undefined;
  name: string = "";

  manufacturer: string = "";

  frDeviceType: string = "";
  spDeviceType: string = "";
  enDeviceType: string = "";

  keywords: string[] = [];
  completeManufacturersList: string[] = [];

  // Coordinates (x, y)
    button1: [number, number] | undefined;
    button2: [number, number] | undefined;
    button3: [number, number] | undefined;
    button4: [number, number] | undefined;
    power: [number, number] | undefined;

  frSteps: string[] = [];
  enSteps: string[] = [];
  spSteps: string[] = [];

  photoCredits: string = "";
  legals: string = "";
  
  photo: string = "";  // filename like "173.jpg"
  //TODO: add other attributes from JSON
}